(function () {
  if (window.__dfpBeacon) { return; }
  window.__dfpBeacon = 1;
  function ck(name) {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].trim();
        if (p.indexOf(name + '=') === 0) { return p.slice(name.length + 1); }
      }
    } catch (e) { /* cookies unavailable */ }
    return '';
  }
  function handleOf(href) {
    var path = String(href || '').split('?')[0];
    while (path.length && path.charAt(path.length - 1) === '/') { path = path.slice(0, -1); }
    var bits = path.split('/');
    return bits[bits.length - 1] || '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var a = t.closest('.dfp a[data-dfp-to], .dfp a[data-dfp-print]');
    if (!a) { return; }
    var root = a.closest('.dfp');
    if (!root) { return; }
    try {
      var payload = JSON.stringify({
        design: root.getAttribute('data-dfp-design') || '',
        from: root.getAttribute('data-dfp-from') || '',
        to: a.getAttribute('data-dfp-to') || '',
        print: a.getAttribute('data-dfp-print') || '',
        handle: handleOf(a.getAttribute('href')),
        vid: ck('_shopify_y'),
        sid: ck('_shopify_s')
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/apps/search/event/picker', payload);
      } else {
        fetch('/apps/search/event/picker', { method: 'POST', body: payload, keepalive: true }).catch(function () {});
      }
    } catch (err) { /* telemetry must never break the click */ }
  }, true);
})();
